import React from 'react';

const Guida = () => {
  return (
    <div style={{
      backgroundColor: 'white',
      color: 'black',
      padding: '20px',
      fontSize: '24px'
    }}>
      <h1>TEST VISIBILE</h1>
      <p>Se vedi questo testo, il componente viene renderizzato</p>
    </div>
  );
};

export default Guida;